import React, { useState, useEffect } from 'react';
import { Paper, Text } from 'library';
import { Provider, Job } from 'models';
import { client, consoleLogInDev } from 'shared';
import CalendarAvailability, { Availability } from './CalendarAvailability';
import WhenDoYouWork from './WhenDoYouWork';
import TwoWeekAvailability from './TwoWeekAvailability';
import { isEmpty } from 'lodash';
import { useUserContext } from 'UserContext';
import PostAJobToBook from './PostAJobToBook';

export default function ProfileProfileAvailability({ provider, job }: { provider: Provider; job?: Job }) {
    const [showCalendarAvailability, setShowCalendarAvailability] = useState<boolean>(false);
    const [showTwoWeekAvailability, setShowTwoWeekAvailability] = useState<boolean>(false);
    const [showPostAJob, setShowPostAJob] = useState<boolean>(false);
    const [availabilityData, setAvailabilityData] = useState<Availability[]>([]);
    const { user } = useUserContext();

    useEffect(() => {
        if (provider && provider.is_background_checked) {
            client(`api/availability-enhanced/?user_id=${provider.user.id}`)
                .then(handleAvailability)
                .catch(consoleLogInDev);
        }
    }, [provider]);

    const getAvailabilityText = () => {
        let availability = [
            provider.availability?.full_time ? 'Full-Time' : '',
            provider.availability?.part_time ? 'Part-Time' : '',
            provider.availability?.occasional ? 'Occasional' : '',
        ].filter((value) => !isEmpty(value));
        return availability.join(', ');
    };

    const handleAvailability = (data: Availability[]) => {
        setShowCalendarAvailability(
            data.length > 0 &&
                !job &&
                !!provider.user.background_checks?.filter(
                    (check) => check.check_type === 'STANDARD' && check.status === 'COMPLETED',
                ),
        );
        setAvailabilityData(data);
        setShowTwoWeekAvailability(
            !!job &&
                data.some(
                    (day) => day.t_06_09 || day.t_09_12 || day.t_12_15 || day.t_15_18 || day.t_18_21 || day.t_21_24,
                ),
        );
        setShowPostAJob(!!user && !user?.has_posted_job);
    };

    function getAvailabilityComponent() {
        if (showPostAJob) {
            return <PostAJobToBook provider={provider} />;
        }
        if (showCalendarAvailability) {
            return <CalendarAvailability provider={provider} />;
        }
        if (showTwoWeekAvailability) {
            return <TwoWeekAvailability availability={availabilityData} />;
        }
        return null;
    }

    return (
        <Paper style={{ marginBottom: 30 }}>
            <Text variant="h2" bold textStyle={{ marginBottom: 12 }}>
                {provider.user.first_name}'s Availability
            </Text>
            <Text variant="body2">
                <strong>Availability:</strong> {getAvailabilityText()}
            </Text>
            <WhenDoYouWork availability={availabilityData} />
            {getAvailabilityComponent()}
        </Paper>
    );
}
